import { TaskEvidenceOutcome } from '@jms/model';

export type TaskEvidenceOutcomeTone = 'success' | 'warning' | 'error' | 'neutral';

/** One tone per outcome so the SOR indicator and the Task Pro chip colour an outcome alike; both missing-evidence outcomes read as errors. */
export const TASK_EVIDENCE_OUTCOME_TONES: Record<TaskEvidenceOutcome, TaskEvidenceOutcomeTone> = {
  [TaskEvidenceOutcome.Captured]: 'success',
  [TaskEvidenceOutcome.Exception]: 'warning',
  [TaskEvidenceOutcome.Outstanding]: 'error',
  [TaskEvidenceOutcome.CompletedWithMissingEvidence]: 'error',
  [TaskEvidenceOutcome.NoneRequired]: 'neutral',
  [TaskEvidenceOutcome.NotApplicable]: 'neutral',
};

/** The SOR indicator is icon-only, so the icon must tell the outcomes apart where the colour repeats. */
export const TASK_EVIDENCE_OUTCOME_ICONS: Record<TaskEvidenceOutcome, string> = {
  [TaskEvidenceOutcome.Captured]: 'fa-regular fa-circle-check',
  [TaskEvidenceOutcome.Exception]: 'fa-regular fa-circle-exclamation',
  [TaskEvidenceOutcome.Outstanding]: 'fa-regular fa-circle-xmark',
  [TaskEvidenceOutcome.CompletedWithMissingEvidence]: 'fa-regular fa-triangle-exclamation',
  [TaskEvidenceOutcome.NoneRequired]: 'fa-regular fa-circle-minus',
  [TaskEvidenceOutcome.NotApplicable]: 'fa-regular fa-ban',
};
